export default __webpack_public_path__ + "static/media/restaurante2.422ce684.jpg";